import React, { useState, useEffect, useRef } from "react";
// import "./FollowersChangeOverTime.scss";
import Loading from "../Loading/Loading";
// import FollowersChangeOverTimeChart from "./FollowersChangeOverTimeChart";
import NoData from "../NoData/NoData";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import { Icon } from "semantic-ui-react";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "../../../../../FbInsights/FBIntervalSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import moment from "moment";
import InstagramPageSelector from "../InstagramPageSelector";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
import PostImpressionsChart from "./PostImpressionsChart";

function PostImpressions(props) {
    const [isNoData, setIsNoDataState] = useState(false);
    const [showAverage, setShowAverage] = useState(true);
    const chart = React.useRef(null);

    useEffect(() => {
        setIsNoDataState(props.pageStatus || props.data?.insta_post_impressions?.nodata);
    }, [props.data, props.pageStatus]);
    const chartLoading = props.chartDataLoading?.insta_post_impressions;

    const downloadCSV = () => {
        let chartName = "Post Impressions";
        let chartData = props.data?.insta_post_impressions.impression_agg || [];
        let downLoadingData = [];
        let formatString = "YYYY-MM-DD HH:mm";
        downLoadingData.push(["Date", "Impressions"]);
        let count = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        chartData.forEach((ele) => {
            count += ele[1];
            downLoadingData.push([moment(ele[0]).tz(tz).format(formatString), ele[1]]);
        });

        downLoadingData.push(["Total", count]);
        downLoadingData.push(["Average", props.data?.insta_post_impressions?.avg_value]);
        downloadCSVData(downLoadingData, props.widget?.name || chartName);
    };

    const downloadPNG = (cb) => {
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, props.widget?.name || "Posts over Time");
                },
            );
    };
    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downloadCSV },
                    { name: "PNG", downloadFn: downloadPNG, showLoader: true },
                ]}
            />
        );
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={props.widget?.name || "Post Impressions"}
                    isIGPage={props.isIGPage}
                    info="This chart shows the total Impressions of posts over time. Average values are calculated by dividing the total impressions by the total number of posts published in the time period selection. An Impression means that the post appeared on the user's screen but the user may or may not have actually seen it."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!isNoData && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("bar")} className={props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>
                            <span onClick={() => props.changeGraphType("line")} className={props.graph_type === "line" ? "active-chart" : ""}>
                                <Icon name="line chart" />
                            </span>
                        </div>
                    )}
                    {!props.isIGPage && !props.isPublic && !props.isResearchDashboard && (
                        <ChartFilterIcon
                            chartFilterApplied={props.chartFilterApplied}
                            changeShowChartFilterOptions={props.changeChartFilter}
                            widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                            name={props.widget.name}
                        />
                    )}
                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {props.isPublic && isNoData ? null : (
                        <MoreOptions
                            className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                            onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!isNoData && (
                            <>
                                {/* <CustomCheckBox
                                    label="Show Unique"
                                    checked={props.showUniqueLines}
                                    onClick={() => props.changeShowUniqueLine(!props.showUniqueLines)}
                                /> */}
                                <CustomCheckBox label="Show Legends" checked={props.showLegend} onClick={() => props.changeShowLegend(!props.showLegend)} />
                                <CustomCheckBox
                                    label="Show Grid Lines"
                                    checked={props.showGridLines}
                                    onClick={() => props.changeShowGridLines(!props.showGridLines)}
                                />
                                <CustomCheckBox label="Show Average" checked={showAverage} onClick={() => setShowAverage((val) => !val)} />
                                {/* <CustomCheckBox label="Show Label" checked={props.showLabel} onClick={() => props.changeShowLabel(!props.showLabel)} /> */}
                                <FBIntervalSelector
                                    aggs_val={props.aggs_val}
                                    appliedFilter={props.appliedFilter}
                                    handleIntervalChange={props.handleIntervalChange}
                                />
                            </>
                        )}
                        {!props.isIGPage && !props.isPublic && !props.isStandardDashboard && !props.isResearchDashboard && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                                <DeleteWidget onClick={props.deleteWidget} />
                            </>
                        )}
                    </ChartOptionsSidebar>
                )}
            </div>
            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chart}>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {chartLoading && <Loading />}
                    {!isNoData && !chartLoading && (
                        <PostImpressionsChart
                            chartData={props.data?.insta_post_impressions}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            graphType={props.graph_type}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                            showAverage={showAverage}
                        />
                    )}
                    {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
                </div>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => increment()}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default PostImpressions;
